import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { combineLatest, Observable } from 'rxjs';
import { map, shareReplay, startWith, switchMap, tap } from 'rxjs/operators';
import { DriverShiftOverviewRegion, DriverShiftOverviewResponse } from 'src/app/types';
import { ShiftService } from '../shift.service';

@Component({
  selector: 'lohi-internal-shift-graph',
  templateUrl: './internal-shift-graph.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InternalShiftGraphComponent implements OnInit {
  public selectedRegionForm = new FormControl(null);
  public regions$: Observable<DriverShiftOverviewResponse>;
  public regionDrivers$: Observable<DriverShiftOverviewRegion[]>;
  public fiveFControl = new FormControl(false);

  constructor(private shiftService: ShiftService) {}

  public ngOnInit(): void {
    this.selectedRegionForm.setValue(this.getRegionId());
    this.regions$ = this.fiveFControl.valueChanges.pipe(
      startWith(false),
      switchMap((value) => this.shiftService.loadDriversOnShiftFF(value)),
      shareReplay(1),
    );
    this.regionDrivers$ = combineLatest([
      this.regions$,
      this.selectedRegionForm.valueChanges.pipe(
        tap((id) => {
          this.storeRegionId(id);
        }),
        startWith(this.selectedRegionForm.value),
      ),
    ]).pipe(
      map(([response, regionID]) => {
        return (response?.regions || []).filter((r) => r.id === regionID);
      }),
    );
  }

  private storeRegionId(id: number) {
    localStorage.setItem('INTERNAL_SELECTED_REGION', `${id}`);
  }

  private getRegionId() {
    return +localStorage.getItem('INTERNAL_SELECTED_REGION');
  }
}
